import { ConcreteEncodable } from "./ConcreteEncodable";

import { ToggleInflightStateResultImplEncoder } from "../../encoder/ToggleInflightStateResultImplEncoder";

import * as CubiqTS from "../../index";
import { ToggleInflightStateResult } from "../ToggleInflightStateResult";

export class ToggleInflightStateResultImpl
  extends ConcreteEncodable
  implements ToggleInflightStateResult
{
  public static enType: string = "com.bcdfx.model.event.ToggleInflightStateResultImpl";

  /*FID=1*/
  public results: Array<CubiqTS.ToggleInflightStateResultItem> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ToggleInflightStateResultImplEncoder.Instance;
    this.setEncodableType(ToggleInflightStateResultImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ToggleInflightStateResultImpl[" +
      "results=" +
      this.results +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
